import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ScheduledCommand } from "../Model/ScheduledCommand";

export async function getScheduledCommand(id) {
	let response = await getAPIResponse("/command-scheduler/scheduled-command/"+id);
	if (response === null) {
		return null;
	}
	let scheduledCommand = ScheduledCommand.createFromResponseData(response);
	return scheduledCommand;
}